"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/tag/style");
var _tag = _interopRequireDefault(require("antd/lib/tag"));
var _react = _interopRequireDefault(require("react"));
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BanTag = function BanTag(_ref) {
  var banned = _ref.banned,
    banExpires = _ref.banExpires,
    _ref$inChannel = _ref.inChannel,
    inChannel = _ref$inChannel === void 0 ? false : _ref$inChannel;
  if (!banned) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_tag.default, {
    color: "#ff7e3c"
  }, "banned ", inChannel ? 'in channel ' : ' ', banExpires ? 'until ' + (0, _momentTimezone.default)(banExpires).format('dddd, MMMM D h:mma, z') : 'permanently');
};
var _default = BanTag;
exports.default = _default;